import { useLocation, useMatches } from 'react-router';
import { hasProperty } from '@gonfalon/collections/hasProperty';
import { matchProjectSettingsFullScreenFlow } from '@gonfalon/navigator/matchers';

import { isFlattenedSettingsEnabled } from './isFlattenedSettingsEnabled';

export function useIsFlatProjectSettingsSurface() {
  const matches = useMatches();
  const location = useLocation();

  return (
    isFlattenedSettingsEnabled() &&
    matches.some((match) => hasProperty(match.handle, 'providesSubnav', 'project-settings')) &&
    !matchProjectSettingsFullScreenFlow(location)
  );
}
